import Logo from '../../../assets/logo.svg'
import FundoRosaLogin from '../../../assets/fundo-rosa-baixo.png'

import { Container } from './styles'

const AuthLayout = ({ children }) => {
  return (
    <Container>
        <img src={FundoRosaLogin} className="wave" alt="Onda cor rosa" />
        <img src={Logo} className="logo" alt="Logo da OnFarm" />
        {children}
    </Container>
  )
}

export default AuthLayout
